import React from "react";

import { useGetRolesTable } from "../../hooks";
import { StyledHubTableHeader } from "./styles";
import { StyledTableCell } from "../../components/HubTable/HubTableHeader/styles";
import { TableCell, TableRow } from "@mui/material";

// const label = name
//       .split("_")
//       .map((word) => {
//         const lower = word.toLowerCase();
//         return lower.charAt(0).toUpperCase() + lower.slice(1);
//       })
//       .join(" ");
//     return { id, label };

const RowSx = {
  "& .MuiTableCell-root": { py: "4px !important" },
  backgroundColor: "hubColors.greyLighter",
};

export const RolePermissionsTableHeader = ({ locationId }) => {
  const { data } = useGetRolesTable({ locationId });
  const roles = data?.roles || [];

  const headCells = roles?.map(({ id, name }) => ({
    id,
    label: name,
  }));
  const ITEMS = [{ id: "permission", label: " " }, ...headCells];

  return (
    <StyledHubTableHeader sx={{ backgroundColor: "hubColors.white" }}>
      <TableRow sx={{ backgroundColor: "hubColors.mainFocusLightest" }}>
        <TableCell colSpan={ITEMS?.length}>Permissions Matrix</TableCell>
      </TableRow>
      <TableRow sx={RowSx}>
        {ITEMS?.map((item) => (
          <StyledTableCell key={item?.id}>{item?.label}</StyledTableCell>
        ))}
      </TableRow>
    </StyledHubTableHeader>
  );
};

export default RolePermissionsTableHeader;
